import * as api from "../../shared/api"
import * as biz_data_helper from "../../shared/biz_data_helper"
// -- import * as _ from "lodash-es"

const content_type = "ProductPartsType"

const create = function () {
  return {
    content_type: "muji",
    age: 29
  }
}
const descriptor = {}

const biz_data = new biz_data_helper.base_entity_helper(
  content_type,
  create,
  descriptor
)

const fields = {
  default: [
    {
      key: "id",
      label: "编号",
      sortable: true,
      thStyle: { width: "60px" }
    },
    { key: "text", label: "类别名称", sortable: true },
    { key: "type_code", label: "分类码", sortable: true },
    {
      key: "parent_id",
      label: "父级id",
    },
    {
      key: "remark",
      label: "备注",
    },

  ]
}

const dataForm = {}

///前端验证
const rules = {}
const methods = {
  ///get
  async getData(_params) {
    let result = await biz_data
      .selectAction({
        params: _params,
        fields: _.map(fields.default, "key")
      })
      .run()

    if (
      result &&
      result[0].result &&
      result[0].result.data &&
      result[0].result.data.ActionResult &&
      result[0].result.data.ActionResult.Result &&
      result[0].result.data.ActionResult.Result.Data.length > 0
    ) {
      return result[0].result.data.ActionResult.Result.Data
    } else {
      return null
    }
  },
  async saveData(item) {
    let batch_actions = []
    if (item.id == "") {
      delete item.id
      batch_actions.push(
        biz_data.insertAction({
          params: item,
          fields: _.map(fields.default, "key")
        }).action({})
      )
    }
    else {
      batch_actions.push(
        biz_data.updateAction({
          params: item,
          fields: _.map(fields.default, "key")
        }).action({})
      )
    }

    let result = await api.query_batch({
      actions: batch_actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  },
  async deleteData(items) {
    let batch_actions = []
    batch_actions.push(
      biz_data.deleteAction({
        params: items
      }).action({})
    )

    let result = await api.query_batch({
      actions: batch_actions
    })
    if (
      result &&
      result.data &&
      result.data.BatchResult &&
      result.data.BatchResult.Actions &&
      result.data.BatchResult.Actions.length > 0
    ) {
      return result.data.BatchResult.Actions
    } else {
      return null
    }
  }
}
export { fields, dataForm, methods, rules, biz_data }
